// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1yyEj","content":"styles_content__1F7O1","selectAll":"styles_selectAll__2ILQM"};